import { useSyncExternalStore } from "react";

let pageTitleOverride: string | null = null;
const listeners = new Set<() => void>();

export const headerStore = {
  setPageTitleOverride: (title: string | null) => {
    pageTitleOverride = title;
    listeners.forEach((l) => l());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot: () => pageTitleOverride,
};

export function useHeaderStore() {
  const title = useSyncExternalStore(headerStore.subscribe, headerStore.getSnapshot);
  return {
    pageTitleOverride: title,
    setPageTitleOverride: headerStore.setPageTitleOverride,
  };
}
